<template>
    <div class="flex items-center gap-2">
        <span class="text-sm font-medium text-gray-500">
            {{ isToday ? t("vue.today") : t("vue.kiosk_da_selected_day") }}:
        </span>
        <input
            :id="inputId"
            v-model="localDate"
            type="date"
            class="rounded-lg border-0 px-3 py-1.5 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
            @change="applyDate"
        />
        <button
            type="button"
            class="rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            @click="goToToday"
        >
            {{ t("vue.today") }}
        </button>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

const props = withDefaults(
    defineProps<{
        date: string;
        routeName: string;
        routeParams?: Record<string, number>;
        inputId?: string;
    }>(),
    {
        routeParams: () => ({}),
        inputId: "kiosk-day-picker",
    },
);

const localDate = ref<string>(props.date);

watch(
    () => props.date,
    (updated: string): void => {
        localDate.value = updated;
    },
);

const toDateString = (date: Date): string => date.toISOString().slice(0, 10);

const isToday = computed(
    (): boolean => props.date === toDateString(new Date()),
);

const visit = (query: Record<string, string>): void => {
    router.get(route(props.routeName, props.routeParams), query, {
        preserveState: false,
    });
};

const applyDate = (): void => {
    visit({ date: localDate.value });
};

const goToToday = (): void => {
    localDate.value = toDateString(new Date());
    visit({});
};
</script>
